<app-component-html-template [(relevantAnalysisTypes)]="relevantAnalysisTypes"
  [packagingComponent]="decoration" [form]="form" [componentSubtypes]="componentSubtypes"
  [callerId]="callerId" [isDecoration]="true" [isPreview]="isPreview" [isTracked]="isTracked"
  [isFormLocked]="isFormLocked" [historyVersions]="historyVersions" [spinnerActive]="spinnerActive"
  [canEditForm]="canEditForm" [isUserValidator]="isUserValidator" [isEditPermitted]="isEditPermitted"
  [imageSource]="imageSource" [componentTypeSelectionLabel]="'component.fields.ofDecoration' | transloco"
  [isDataExchangeSubRequest]="isDataExchangeSubRequest"
  [isInOngoingDataExchange]="isInOngoingDataExchange"
  [subRequestInfo]="subRequestInfo"
  (commentAdded)="onSubRequestCommentAdded($event)"
  [changedMaterialsInfo]="changedMaterialsInfo" (submitted)="onComponentSubmit($event)"
  (finishSubRequestClicked)="onFinishSubRequest($event)"
  (approveSubRequestClicked)="onApproveSubRequest()"
  (reopenSubRequestClicked)="onReopenSubRequest()"
  (createDataExchangeRequestClicked)="createDataExchangeRequest($event)"
  (decorationSubtypeChanged)="onDecorationTypeChanged($event)"
  (historicVersionClicked)="loadHistoryVersions(decoration.id)"
  (historicVersionChanged)="onHistoryVersionChange($event)" (versionRenamed)="changeDecorationVersionName($event)"
  (materialChangeHandled)="handleMaterialChange($event)">

  <h1 header>{{ 'component.decoration' | transloco }}</h1>

  <div image>
    <app-image-upload [canEditForm]="canEditForm" [images]="decoration.images" (filesEdited)="onFilesEdited()">
    </app-image-upload>
  </div>

  <div certificate>
    <app-certificate-upload [canEditForm]="canEditForm" [certificates]="decoration.certificates" [certificateTypes]="allCertificateTypes" (filesEdited)="onFilesEdited()">
    </app-certificate-upload>
  </div>

  <div pdf>
    <app-pdf-upload [canEditForm]="canEditForm" [pdfs]="decoration.documents" (filesEdited)="onFilesEdited()">
    </app-pdf-upload>
  </div>

</app-component-html-template>
